import { ReactNode } from "react";

export enum UnsavedChangesDecision {
  Save = "save",
  Discard = "discard",
  Cancel = "cancel",
}

export type TAttemptUnsavedChangesConfirmOptions = {
  isNavigationTrigger?: boolean;
  isSaveProhibited?: boolean;
  onSave?: () => void | Promise<void>;
  onDiscardChanges?: () => void | Promise<void>;
  onCancel?: () => void | Promise<void>;
  content?: ReactNode;
};

export type TUnsavedChangesContextValue = {
  attemptUnsavedChangesConfirm: (
    options: TAttemptUnsavedChangesConfirmOptions,
  ) => Promise<UnsavedChangesDecision>;
};
